import { useRef } from "react";

const useSummaryReportForm = () =>
{
  const initValues = {
    clientId: "",
    practiceId: "",
    startDate: "",
    endDate: ""
  }

  const data = initValues;
  const selectRef = useRef(null);
  const clientSelectRef = useRef(null);
  const clearSelect = () => {
    selectRef.current?.select?.setValue({ label: "Select Practice", value: "-1" });
    clientSelectRef.current?.select?.setValue(null);
  };
  return {data, selectRef, clientSelectRef, clearSelect}
}

export default useSummaryReportForm
